// Components imports
import { defineAsyncComponent } from "vue";

// Lazy-loaded components
const COMPONENTS = {
    UserPanel: defineAsyncComponent(() => import("@/components/UserPanel.vue")),
    InfoPage: defineAsyncComponent(() =>
        import("@/components/pages/user/InfoPage.vue")
    ),
    BillPage: defineAsyncComponent(() =>
        import("@/components/pages/user/BillPage.vue")
    ),
    AdjustmentsPage: defineAsyncComponent(() =>
        import("@/components/pages/user/AdjustmentPage.vue")
    ),
    RequestPage: defineAsyncComponent(() =>
        import("@/components/pages/user/RequestPage.vue")
    ),
    ShowRequest: defineAsyncComponent(() =>
        import("@/components/pages/user/ShowRequest.vue")
    ),
    NewRequest: defineAsyncComponent(() =>
        import("@/components/pages/user/NewRequest.vue")
    ),
    MessagePage: defineAsyncComponent(() =>
        import("@/components/pages/user/MessagePage.vue")
    ),
    TutorialSection: defineAsyncComponent(() =>
        import("@/components/pages/user/sections/TutorialSectionDriver.vue")
    ),
};

// Route configurations
const ROUTE_BASE = "/userpanel";

const userRoutes = [
    {
        path: ROUTE_BASE,
        name: "UserPanel",
        component: COMPONENTS.UserPanel,
        redirect: { name: "messagesPage" },
        meta: {
            requiresAuthLevelOnePlus: true,
            breadcrumb: "پنل کاربری",
            title: "پنل کاربری",
        },
        children: [
            {
                path: "dashboard",
                name: "messagesPage",
                component: COMPONENTS.MessagePage,
                meta: { breadcrumb: "پیام‌ها" },
            },
            {
                path: "info",
                name: "infoPage",
                component: COMPONENTS.InfoPage,
                meta: { breadcrumb: "اطلاعات کاربری" },
            },
            {
                path: "bills",
                name: "billPage",
                component: COMPONENTS.BillPage,
                meta: { breadcrumb: "صورتحساب‌ها" },
            },
            {
                path: "adjustments",
                name: "adjustmentsPage",
                component: COMPONENTS.AdjustmentsPage,
                meta: { breadcrumb: "تعدیلی ها" },
            },
            {
                path: "requests",
                name: "requestsPage",
                component: COMPONENTS.RequestPage,
                meta: { breadcrumb: "درخواست‌ها", requiresAuthLevelOne: true },
            },
            {
                path: "requests/:id",
                name: "showRequest",
                component: COMPONENTS.ShowRequest,
                meta: {
                    breadcrumb: "نمایش درخواست",
                    requiresAuthLevelOne: true,
                },
            },
            {
                path: "requests/newrequest",
                name: "newRequest",
                component: COMPONENTS.NewRequest,
                meta: {
                    breadcrumb: "درخواست جدید",
                    requiresAuthLevelOne: true,
                },
            },
            {
                path: "tutorials",
                name: "tutorialSection",
                component: COMPONENTS.TutorialSection,
                meta: {
                    breadcrumb: "آموزش ها",
                    requiresAuthLevelOne: true,
                },
            },
        ],
    },
];

export default userRoutes;
